function showPage(id) {
  var target = document.getElementById('page-' + id);
  if (!target) return;
  document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
  target.classList.add('active');
  document.querySelectorAll('.nav a').forEach(a => a.classList.remove('active'));
  var navEl = document.getElementById('nav-' + id);
  if (navEl) navEl.classList.add('active');
  window.scrollTo(0, 0);
}

function filterColl(key, el) {
  document.querySelectorAll('.ftab').forEach(t => t.classList.remove('active'));
  if (el) el.classList.add('active');
  var sections = {
    'midnight-rider': 'sec-midnight-rider',
    'get-back-cross-body': 'sec-get-back-cross-body',
    'active-patrol': 'sec-active-patrol',
    'urban-crown': 'sec-urban-crown',
    'pulse-activator': 'sec-pulse-activator',
    'battle-scars': 'sec-battle-scars',
    'phantom-hoodie': 'sec-phantom-hoodie',
    'vanguard': 'sec-vanguard',
    'street-lion-power-fist': 'sec-street-lion-power-fist',
    'cali-dreams': 'sec-cali-dreams',
    'aztec-virgen-mary': 'sec-aztec-virgen-mary',
    'la-original': 'sec-la-original'
  };
  if (key === 'all') {
    document.querySelectorAll('.coll-section,.sec-divider').forEach(s => s.style.display = '');
  } else {
    document.querySelectorAll('.coll-section').forEach(s => s.style.display = 'none');
    document.querySelectorAll('.sec-divider').forEach(s => s.style.display = 'none');
    var target = document.getElementById(sections[key]);
    if (target) target.style.display = '';
  }
}

function pdpChipClick(el) {
  var row = el.closest('.pdp-opt-row');
  row.querySelectorAll('.pdp-opt-chip').forEach(c => c.classList.remove('active'));
  el.classList.add('active');
  el.querySelector('input').checked = true;
  pdpUpdateVariant();
}

function pdpUpdateVariant() {
  if (typeof PDP_VARIANTS === 'undefined') return;
  var selected = [];
  document.querySelectorAll('.pdp-opt-group').forEach(function(group, i) {
    var checked = group.querySelector('input:checked');
    selected[i] = checked ? checked.value : null;
  });
  var match = PDP_VARIANTS.find(function(v) {
    return v.options.every(function(val, i) { return val === selected[i]; });
  });
  var select = document.getElementById('pdp-variant-select');
  var btn = document.querySelector('.pdp-atc');
  if (match) {
    if (select) select.value = match.id;
    if (btn) {
      btn.disabled = !match.available;
      btn.style.opacity = match.available ? '1' : '.4';
      btn.style.cursor = match.available ? 'pointer' : 'not-allowed';
      btn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    }
    var priceEl = document.querySelector('.pdp-price');
    if (priceEl && match.price) priceEl.textContent = match.price;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.search.indexOf('view=collections') !== -1) {
    showPage('collections');
  }
});
